<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row ">
                <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box">
                        <span class="info-box-icon bg-info elevation-1"><i class="fas fa-anchor"></i></span>

                        <div class="info-box-content">
                            <span class="info-box-text">Saldo Awal Tahun</span>
                            <span class="info-box-number">                            
                            <small>Rp {{ returnRupiah(salwal) }}</small>
                            </span>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
                <!-- /.col -->
                <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box mb-3">
                        <span class="info-box-icon bg-danger elevation-1"><i class="fas fa-plus-square"></i></span>

                        <div class="info-box-content">
                            <span class="info-box-text">Barang Masuk</span>
                            <span class="info-box-number">
                                <small>Rp {{ returnRupiah(bm) }}</small></span>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
                <!-- /.col -->

                <!-- fix for small devices only -->
                <div class="clearfix hidden-md-up"></div>

                <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box mb-3">
                        <span class="info-box-icon bg-success elevation-1"><i class="fas fa-minus-square"></i></span>

                        <div class="info-box-content">
                            <span class="info-box-text">Barang Keluar</span>
                            <span class="info-box-number">
                                <small>Rp {{ returnRupiah(bk) }}</small></span>
                            </span>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
                <!-- /.col -->
                <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box mb-3">
                        <span class="info-box-icon bg-warning elevation-1"><i class="fas fa-wallet"></i></span>

                        <div class="info-box-content">
                            <span class="info-box-text">Saldo Akhir</span>
                            <span class="info-box-number">
                                <small>Rp {{ returnRupiah(salkhir) }}</small></span>
                            </span>
                        </div>
                    <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
            <!-- /.col -->
            </div>
            <!-- /.row -->

            <div class="row">
                <!-- Left col -->
                <div class="col-md-8">
                    <!-- MAP & BOX PANE -->
                    <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Barang Masuk Terbaru</h3>

                        <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fas fa-minus"></i>
                        </button>
                        <button type="button" class="btn btn-tool" data-card-widget="remove">
                            <i class="fas fa-times"></i>
                        </button>
                        </div>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body p-0">
                        <div class="table-responsive">
                        <table class="table m-0">
                            <thead>
                                <tr>
                                    <th>Tanggal</th>
                                    <th>Barang</th>
                                    <th align="center">Qty</th>
                                    <th align="right">Harga</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="barangmasuk in barangmasuks" :key="barangmasuk.id">
                                    <td>{{barangmasuk.tanggal_masuk}}</td>
                                    <td>{{barangmasuk.nama_barang}}</td>
                                    <td align="right">{{barangmasuk.qty}}</td>
                                    <td align="right">{{returnRupiah(barangmasuk.harga)}}</td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                <!-- /.card-body -->
                </div>
                <!-- /.card -->
                <!-- /.card -->
            </div>
            <!-- /.col -->

            <div class="col-md-4">
                <!-- Info Boxes Style 2 -->
                <div class="info-box mb-3 bg-secondary">
                <span class="info-box-icon"><i class="fas fa-tag"></i></span>

                <div class="info-box-content">
                    <span class="info-box-text">Kategori Barang</span>
                    <span class="info-box-number">{{ kb }}</span>
                </div>
                <!-- /.info-box-content -->
                </div>
                <!-- /.info-box -->
                <div class="info-box mb-3 bg-success">
                <span class="info-box-icon"><i class="fas fa-archive"></i></span>

                <div class="info-box-content">
                    <span class="info-box-text">Barang</span>
                    <span class="info-box-number">{{ barang }}</span>
                </div>
                <!-- /.info-box-content -->
                </div>
                <!-- /.info-box -->
                <div class="info-box mb-3 bg-danger">
                <span class="info-box-icon"><i class="fas fa-box"></i></span>

                <div class="info-box-content">
                    <span class="info-box-text">Ruangan</span>
                    <span class="info-box-number">{{ ruangan }}</span>
                </div>
                <!-- /.info-box-content -->
                </div>
                <!-- /.info-box -->
                <div class="info-box mb-3 bg-info">
                <span class="info-box-icon"><i class="fas fa-address-card"></i></span>

                <div class="info-box-content">
                    <span class="info-box-text">Penyedia</span>
                    <span class="info-box-number">{{ penyedia }}</span>
                </div>
                <!-- /.info-box-content -->
                </div>
                <!-- /.info-box -->
            </div>
            <!-- /.col -->
            </div>
            <!-- /.row -->
        </div><!--/. container-fluid -->
    </section>
</template>

<script>
    export default {
        data () {
            return {
                salwal: '',
                bm:'',
                bk: '',
                salkhir:'',
                kb:'',
                barang:'',
                ruangan:'',
                penyedia:'',
                barangmasuks : {},
            }
        },
        methods: {
            getResults(){
                axios.get("/api/dashboard").then(({ data }) => (this.kb = data.data.kb, this.barang = data.data.barang,this.ruangan = data.data.ruang,this.penyedia = data.data.penyedia,this.salwal = data.data.salwal,this.bm = data.data.bm,this.bk = data.data.bk,this.salkhir = data.data.salkhir, this.barangmasuks = data.data.lastbm));
            },
            returnRupiah(val){
                if (val === null || val === undefined || val === '') return 0;

				return new Intl.NumberFormat('id-ID', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2, // tetap tampil .5 / .50
				}).format(val);
            }
        },        
        mounted() {
            console.log('Component mounted.')
        },
        created() {
            this.$Progress.start();
            this.getResults();
            this.$Progress.finish();
        }
    }
    
</script>